import React from 'react';

import styles from './ZeroState.scss';

function ZeroState() {
  return (
    <div className={styles.zeroState}>
      <div className={styles.zeroStateTitle}>SUPPORTED SEARCH TYPES</div>
      <div className={styles.zeroStateOptions}>
        <span>User Messages</span>
        <span>Bot Responses</span>
        <span>Steps</span>
        <span>Skills</span>
        <span>Skill Sets</span>
      </div>
    </div>
  );
}

ZeroState.propTypes = {};
ZeroState.defaultProps = {};

export default ZeroState;
